import { render, staticRenderFns } from "./CustomersPage.html?vue&type=template&id=39bf1b60&scoped=true&"
import script from "./CustomersPage.ts?vue&type=script&lang=ts&"
export * from "./CustomersPage.ts?vue&type=script&lang=ts&"
import style0 from "./CustomersPage.scss?vue&type=style&index=0&id=39bf1b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bf1b60",
  null
  
)

export default component.exports